import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TitanPlanRequest } from '@/models/payment';
import {} from '@/services/paymentsQuery';
import { TwoInputConnection } from '@/pages/company/common/TwoInputConnection';
import { usePaymentsMutations } from '@/services/paymentsMutations';
import { useHandleResponse } from '@/lib/hooks/useHandleResponse';
interface TitanPlanConnectProps {
    onClose?: () => void;
    onSaveSuccess: any;
}

export const TitanPlanConnect = (props: TitanPlanConnectProps) => {
    const { t } = useTranslation();
    const [titanPlan, setTitanPlanData] = useState<TitanPlanRequest>({} as any);
    const { setupTitanPlan } = usePaymentsMutations();
    const onClick = () => {
        setupTitanPlan.mutate(titanPlan);
    };

    useHandleResponse({
        isSuccess: setupTitanPlan.isSuccess,
        error: setupTitanPlan.error,
        isPending: setupTitanPlan.isPending,
        successAlertMessage: t('titan_plan_connected'),
        isSuccessCallBack: () => {
            props.onSaveSuccess();
        }
    });

    return (
        <>
            <TwoInputConnection
                input1Value={titanPlan?.clientId}
                input2Value={titanPlan?.secretKey}
                input1Label={t('titan_plan_clientId')}
                input2Label={t('titan_plan_secret_key')}
                input1Placeholder={t('')}
                input2Placeholder={t('')}
                input1OnChange={(e: any) => {
                    setTitanPlanData((prev) => ({
                        ...prev,
                        clientId: e.target.value
                    }));
                }}
                input2OnChange={(e) => {
                    setTitanPlanData((prev) => ({
                        ...prev,
                        secretKey: e.target.value
                    }));
                }}
                primaryDisabled={!titanPlan.clientId || !titanPlan?.secretKey}
                primaryButtonTitle={t('connect')}
                secondaryButtonTitle={t('cancel')}
                onClickPrimary={onClick}
                onClickSecondary={() => {
                    props.onClose?.();
                }}
            />
        </>
    );
};
